import { useState } from 'react';
import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';
import { SpaceBetween } from '@amzn/awsui-components-react';

import NavigationBreadcrumbs from '../../common/navigation/NavigationBreadcrumbs';
import SideNavigationMenu from '../../common/navigation/SideNavigationMenu';
import Paths from '../../common/paths/paths';
import { BackfillRunsTable, BackfillItemsTable } from '../../components/ContentBackfill';
import useAppDrawers from '../../components/ChatbotWidget/useAppDrawers';
import { BackfillRun } from '../../services/content-backfill-service';
import {
  ContentBackfillTelemetryEvent,
  trackContentBackfillEvent
} from '../../components/ContentBackfill/telemetry';

const breadcrumbs = {
  items: [
    { text: Paths.Admin.name, href: Paths.uploadLicense.url },
    { text: Paths.contentBackfill.name, href: Paths.contentBackfill.url }
  ]
};

const ContentBackfillPage = () => {
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [selectedRun, setSelectedRun] = useState<BackfillRun | null>(null);
  const drawerProps = useAppDrawers();

  const handlePageView = () => {
    trackContentBackfillEvent(ContentBackfillTelemetryEvent.PAGE_VIEW);
  };

  const handleRunSelected = (run: BackfillRun | null) => {
    setSelectedRun(run);
    if (run) {
      trackContentBackfillEvent(ContentBackfillTelemetryEvent.RUN_SELECTED, {
        runId: run.jobId,
        status: run.status
      });
    }
  };

  const handleRowExpanded = (sourceSourceId: string) => {
    trackContentBackfillEvent(ContentBackfillTelemetryEvent.ITEM_SELECTED, {
      itemId: sourceSourceId
    });
  };

  const handleCatalogicalLinkClick = (itemId: string) => {
    trackContentBackfillEvent(ContentBackfillTelemetryEvent.CATALOGICAL_LINK_CLICKED, {
      itemId
    });
  };

  return (
    <AppLayout
      content={
        <SpaceBetween size="l">
          <BackfillRunsTable
            onRunSelected={handleRunSelected}
            onPageView={handlePageView}
          />
          {selectedRun && (
            <BackfillItemsTable
              runId={selectedRun.jobId}
              onRowExpanded={handleRowExpanded}
              onCatalogicalLinkClick={handleCatalogicalLinkClick}
            />
          )}
        </SpaceBetween>
      }
      breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
      navigation={<SideNavigationMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
      {...drawerProps}
    />
  );
};

export default ContentBackfillPage;
